import { createContext, useContext, useEffect, useState } from "react";
import api from "../../../api/resources";

export const IndicatorsContext = createContext(null);

export function IndicatorsProvider({ children }) {
  const [indicators, setIndicators] = useState([]);
  const [loading, setLoading] = useState(true);

  const init = async () => {
    const initIndicators = async () => {
      const response = await api.getIndicators();
      if (response.ok) {
        const jsonResponse = await response.json();
        setIndicators(jsonResponse);
      }
    };

    setLoading(true);
    await initIndicators();
    setLoading(false);
  };

  useEffect(() => {
    init();
  }, []);

  const value = {
    indicators,
    loading: loading,
  };

  return <IndicatorsContext value={value}>{children}</IndicatorsContext>;
}

export function useIndicators() {
  return useContext(IndicatorsContext);
}
